const fromSeconds = (value) => {
  const seconds = value?.seconds ?? value?._seconds;
  if (seconds == null) return null;
  return new Date(seconds * 1000);
};

export const toDate = (value) => {
  if (!value) return null;
  if (value.toDate) return value.toDate();
  if (value instanceof Date) return value;
  if (typeof value === 'number') {
    return value > 1e12 ? new Date(value) : new Date(value * 1000);
  }
  if (typeof value === 'string') return new Date(value);
  return fromSeconds(value);
};

export const toISOString = (value) => {
  const date = toDate(value);
  if (!date || Number.isNaN(date.getTime())) return null;
  return date.toISOString();
};
